import { createContext, useContext, useState } from "react";

const CalcContext = createContext(null);

export function CalcProvider({ children }) {
  const [calc, setCalc] = useState(null);
  return <CalcContext.Provider value={{ calc, setCalc }}>{children}</CalcContext.Provider>;
}

export function useCalc() {
  return useContext(CalcContext);
}
